import priceSimulator3dManifest from './price-simulator-3d/manifest';
import boxGeneratorManifest from './box-generator/manifest';
import catalogManifest from './catalog/manifest';
import consignmentManifest from './consignment/manifest';
import operationalPurchasesManifest from './operational-purchases/manifest';
import eagleDesktopManifest from './eagle-desktop/manifest';
import makerworldImportManifest from './makerworld-import/manifest';
import polaroidCreatorManifest from './polaroid-creator/manifest';

export const EXTENSION_CATALOG = [
  priceSimulator3dManifest,
  boxGeneratorManifest,
  catalogManifest,
  consignmentManifest,
  operationalPurchasesManifest,
  eagleDesktopManifest,
  makerworldImportManifest,
  polaroidCreatorManifest,
];

export const findExtension = (id) => EXTENSION_CATALOG.find((ext) => ext.id === id);
